import { IEffectImmunityResourceSetWide, IEffectResourceSet, ResourceSchemaSet } from '@nova/types';
import { ReadonlyDeep, TupleToUnion, ValueOf } from 'type-fest';

import { actionHinderanceEffects, buffEffects, debuffEffects, immunityEffects } from '../configs/entities/effects';

// Composites
export type AllCompositeType = typeof buffEffects & typeof debuffEffects & typeof actionHinderanceEffects;
export type BuffEffectKey = keyof typeof buffEffects;
export type DebuffEffectKey = keyof typeof debuffEffects;
export type HinderanceEffectKey = keyof typeof actionHinderanceEffects;
export type AllCompositeKey = BuffEffectKey | DebuffEffectKey | HinderanceEffectKey;

/**
 * Maps each composite name to a union of its primitives
 */
export type CompositePrimitiveMap = {
  [K in AllCompositeKey]: TupleToUnion<AllCompositeType[K]['primitives']>
};

// Immunities
export type ImmunityEffectType = typeof immunityEffects;
export type ImmunityEffectKey = keyof ImmunityEffectType;
export type ImmunityPriority = ValueOf<ImmunityEffectType>['priority'];

export type BuffEffectSet = Record<string, IEffectResourceSet>;
export type DebuffEffectSet = Record<string, IEffectResourceSet>;
export type HinderanceEffectSet = Record<string, IEffectResourceSet>;
export type ImmunityEffectSet = Record<string, IEffectImmunityResourceSetWide>;

// Check all
buffEffects satisfies BuffEffectSet;
debuffEffects satisfies DebuffEffectSet;
actionHinderanceEffects satisfies HinderanceEffectSet;
immunityEffects satisfies ReadonlyDeep<ImmunityEffectSet>;

export interface IEffectImmunityResourceSet {
  readonly priority: ImmunityPriority;
  readonly disable: readonly AllCompositeKey[];
  readonly resources: Readonly<ResourceSchemaSet>;
}
